import React from "react";
import { stringToColor } from "../../utils";
import "./reportlist.scss";

interface Props {
  data: { name: string; value: number }[]
  label: string
  header: string
  colorCoded?: boolean
}

const ReportList = ({ data, label, header, colorCoded }: Props) => {
  const totalVisits = data.reduce((sum, item) => sum + item.value, 0);

  return (
    <ul className="report-list">
      {header && <div className="header">{header}</div>}
      {data.map((item, index) => {
        const percentage = totalVisits > 0 ? ((item.value/ totalVisits) * 100).toFixed(1) : "0.0";
        return (
          <li key={index} className="list-item">
            <span className="name" style={colorCoded ? { color: stringToColor(item.name) } : {}}>{item.name}</span>
            <span className="stats">{item.value} ({percentage}%)</span>
          </li>
        );
      })}
    </ul>
  );
};

export default ReportList;